<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 3C11.4477 3 11 3.44772 11 4L11 11L4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13L11 13L11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20L13 13L20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H13L13 4C13 3.44772 12.5523 3 12 3Z"
            fill="#9AA1AE"
        />
    </svg>
</template>
